import styled, { css } from 'styled-components';
import theme from '../../../theme';
import Avatar from '../avatar';
const getHorizontalPadding = (size) => {
    switch (size) {
        case 'small':
            return '24px';
        case 'medium':
        case 'extra-large':
        case 'full':
        case 'large':
            return '54px';
        default:
            return '54px';
    }
};
const getVerticalPadding = (size) => {
    switch (size) {
        case 'small':
            return '24px';
        case 'medium':
        case 'extra-large':
        case 'full':
        case 'large':
            return '32px';
        default:
            return '32px';
    }
};
const smallModal = ({ $noPadding }) => css `
  width: 540px;
  ${ModalContent} {
    padding: ${$noPadding ? 0 : '24px'};
  }
  ${ModalHeader},${ModalFooter} {
    padding: ${$noPadding ? 0 : '16px 24px'};
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    ${ModalContent},${ModalHeader},${ModalFooter} {
      padding: ${$noPadding ? 0 : `${theme.spacing.md}px ${theme.spacing.sm + theme.spacing.xs}px`};
      border-radius: 0;
    }
  }
`;
const mediumModal = ({ $noPadding }) => css `
  width: 760px;
  ${ModalContent} {
    padding: ${$noPadding ? 0 : '54px 96px'};
  }
  ${ModalHeader},${ModalFooter} {
    padding: ${$noPadding ? 0 : '16px 96px'};
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    ${ModalContent},${ModalHeader},${ModalFooter} {
      border-radius: 0;
    }
  }
`;
const largeModal = ({ $noPadding }) => css `
  width: 1080px;
  ${ModalContent} {
    padding: ${$noPadding ? 0 : '54px 96px'};
  }
  ${ModalHeader},${ModalFooter} {
    padding: ${$noPadding ? 0 : '16px 96px'};
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    ${ModalContent},${ModalHeader},${ModalFooter} {
      border-radius: 0;
    }
  }
`;
const extraLargeModal = ({ $noPadding }) => css `
  width: 1300px;
  ${ModalContent} {
    padding: ${$noPadding ? 0 : '54px 96px'};
  }
  ${ModalHeader},${ModalFooter} {
    padding: ${$noPadding ? 0 : '16px 96px'};
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    ${ModalContent},${ModalHeader},${ModalFooter} {
      border-radius: 0;
    }
  }
`;
const fullModal = ({ $noPadding }) => css `
  width: calc(100vw - 128px);
  ${ModalContent} {
    padding: ${$noPadding ? 0 : '54px 96px'};
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    ${ModalContent},${ModalHeader},${ModalFooter} {
      border-radius: 0;
    }
  }
`;
const defaultModal = ({ $noPadding }) => css `
  width: fit-content;
  ${ModalContent} {
    padding: ${$noPadding ? 0 : '54px 96px'};
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    ${ModalContent},${ModalHeader},${ModalFooter} {
      border-radius: 0;
    }
  }
`;
export const ModalBody = styled.div ``;
export const ModalHeader = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 32px;
  box-sizing: border-box;
`;
export const ModalFooter = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  border-top: 1px solid ${({ theme }) => theme.colors.primary};
  width: 100%;
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
`;
export const ModalContent = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  width: 100%;

  border-radius: ${({ $withHeader, $withFooter }) => ($withHeader || $withFooter ? '0px 0px' : '4px 4px')};

  min-height: 200px;
  transition: height 100ms linear;
  box-sizing: border-box;

  @media (max-width: ${theme.breakpoints.md}px) {
    border-radius: 0;
  }
`;
export const ModalContainer = styled.div `
  position: relative;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 10px;
  height: fit-content;
  margin: auto;
  .hd-modal-with-icon {
    &.hd-modal-horizontal {
      padding: 0px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
      padding: 20px;
      &.hd-modal-horizontal {
        padding: 0px;
      }
    }
  }

  @media (max-width: ${theme.breakpoints.md}px) {
    width: 100vw;
    min-height: 100vh;
    border-radius: 0;
    box-shadow: none;
  }

  ${ModalBody} {
    width: 100%;

    display: flex;
    flex-direction: column;
    overflow: visible;
    box-sizing: border-box;
  }

  ${({ $size, $noPadding }) => $size === 'small'
    ? smallModal({ $noPadding })
    : $size === 'medium'
        ? mediumModal({ $noPadding })
        : $size === 'large'
            ? largeModal({ $noPadding })
            : $size === 'extra-large'
                ? extraLargeModal({ $noPadding })
                : $size === 'full'
                    ? fullModal({ $noPadding })
                    : defaultModal({ $noPadding })}

  ${({ $size, $noPadding }) => !$noPadding
    ? css `
          ${ModalHeader},${ModalFooter}, ${ModalContent} {
            padding-inline: ${getHorizontalPadding($size)};

            @media (max-width: ${theme.breakpoints.md}px) {
              padding-inline: ${theme.spacing.sm + theme.spacing.xs}px;
            }
          }
          ${ModalContent} {
            padding-block: ${getVerticalPadding($size)};
          }
          ${ModalHeader},${ModalFooter} {
            padding-block: ${theme.spacing.md}px;

            @media (max-width: ${theme.breakpoints.md}px) {
              padding-block: ${theme.spacing.sm + theme.spacing.xs}px;
            }
          }
        `
    : css `
          ${ModalHeader},${ModalFooter} {
            padding-block: ${theme.spacing.md}px;
            padding-inline: ${theme.spacing.xl}px;
          }
        `}

  @media (max-width: ${theme.breakpoints.md}px) {
    padding-inline: 0; 
    padding-block: 0;
  }
`;
export const ModalWrapper = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  padding: 32px 0;
  box-sizing: content;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.grey_1}bb;
  z-index: 1001;

  @media (max-width: ${theme.breakpoints.md}px) {
    padding: 0;
    overflow: auto;
  }

  animation: fadein 0.3s;
  ${ModalContainer} {
    animation: grow 0.3s;
  }

  /* forwards is load-bearing: React unmounts on its own 300ms timer, a
     separate clock from the animation. Without a fill mode the element
     reverts to opacity 1 / scale 1 the instant the animation ends, flashing
     the closed modal back at full size whenever React's removal lands late. */
  &.fade-out {
    animation: fadeout 0.3s forwards;
    ${ModalContainer} {
      animation: shrink 0.3s forwards;
    }
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes grow {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  @keyframes shrink {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(0);
    }
  }
`;
export const ModalLogo = styled.div `
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 200;
`;
export const ModalAvatar = styled(Avatar) `
  position: absolute;
  top: 0;
  left: 0;
`;
